import create from "zustand";

import { DeepNonNullable } from "@/types/index.types";

type AuthStore = {
  accessToken: string | null;
  authInitialized: boolean; // this tracks that initAuth has finished
  isLoggedIn: boolean;

  logout: () => void;
  setAccessToken: (token: string | null) => void;
  setAuthInitialized: () => void;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
};

const useAuthStore = create<AuthStore>((set) => ({
  authInitialized: false,
  accessToken: null,
  isLoggedIn: false,
  setAccessToken: (token) => set({ accessToken: token }),
  setAuthInitialized: () => set({ authInitialized: true }),
  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn, authInitialized: true }),
  logout: () =>
    set({
      accessToken: null,
      isLoggedIn: false,
    }),
}));

type AuthData = DeepNonNullable<AuthStore>;

/**
 * Returns the auth store data if an access token exists. Use this to avoid having to check for falsy values when you know an access token exists in a given context.
 * @returns The auth store data
 */
const getAuthData = (): AuthData => {
  const { accessToken, ...rest } = useAuthStore.getState();

  if (!accessToken) {
    throw new Error("Access token does not exist");
  }

  return {
    accessToken,
    ...rest,
  };
};

export { getAuthData, useAuthStore, type AuthData, type AuthStore };
